import { AppPageLayout } from "@/components/common/AppPageLayout";
import { studyByIdQueryOptions } from "@/features/studies/api/selectStudies";
import { Outlet, createFileRoute, useMatch } from "@tanstack/react-router";

function StudyIdLayout() {
    // The study overview has charts and a wide clinician table, so it uses the full width.
    // Edit and invite are forms and keep the narrower column.
    const onOverview = Boolean(useMatch({ from: "/_app/studies/$studyId/", shouldThrow: false }));
    return (
        <AppPageLayout width={onOverview ? "full" : "md"} as="div">
            <Outlet />
        </AppPageLayout>
    );
}

export const Route = createFileRoute("/_app/studies/$studyId")({
    component: StudyIdLayout,
    loader: async ({ context, params }) => {
        try {
            await context.queryClient.ensureQueryData(studyByIdQueryOptions(params.studyId));
        } catch {
            // New study ids won't exist yet.
        }
    },
});
